// extracted by mini-css-extract-plugin
export var article = "post-module--article--3l8Nx";